function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9854 0H0.0146484C0.00655833 0 0 0.00655833 0 0.0146484V49.9854C0 49.9934 0.00655833 50 0.0146484 50H49.9854C49.9934 50 50 49.9934 50 49.9854V0.0146484C50 0.00655833 49.9934 0 49.9854 0Z",
  fill: "#37AEE2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4336 39.4531C18.3594 39.4531 18.457 39.0625 18.1641 38.0859L15.0391 27.832L38.9648 13.7695",
  fill: "#C8DAEA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4336 39.4531C20.1172 39.4531 20.5078 39.0625 20.9961 38.6719L25.3906 34.4727L19.9219 31.1523",
  fill: "#A9C9DD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9218 31.1521L33.1054 40.8201C34.4726 41.699 35.6445 41.2107 36.0351 39.4529L41.4062 14.2576C41.8945 12.1091 40.5273 11.1326 39.0625 11.8162L7.7148 23.9255C5.66402 24.7068 5.66402 25.9763 7.32417 26.4646L15.4296 29.0037L33.9843 17.1873C34.8632 16.699 35.6445 16.8943 35.0586 17.5779",
  fill: "#F6FBFE"
});

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.203d03c2.svg";
export { ForwardRef as ReactComponent };